// extracted by mini-css-extract-plugin
export default {"root":"AQ3dHC","bg":"BQMnwy","bg2":"NGPy1w"};